import React, { useCallback, useState } from 'react'

import { DateTime } from 'luxon'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import DatePicker from '@/Form/V2/DatePicker'
import CheckboxEl from '@/Form/V2/Managed/CheckboxEl'

import { isTrue } from '@root/utility'

export default PageWrapper(function OrdersExportPage (props)
{
	const [state, setState] = useState(
	{
		start: DateTime.now().startOf('month').toISODate(),
		end: DateTime.now().endOf('month').toISODate()
	});

	const [includes_exported, setIncludesExported] = useState(false);

	const { start, end } = state;

	const toggleExported = useCallback(function (e, name)
	{
		setIncludesExported(checked => !isTrue(checked));
	},
	[]);

	const handleChange = useCallback(function ({ value, e, name })
	{
		if (!name) return;

		setState(function (state)
		{
			return { ...state, [name]: value || '' };
		});
	},
	[]);

	const inc_param = includes_exported
	? '&includes_exported=true'
	: '';

	return (
		<Layout history={ props.history } page_title="Export comptabilité">

			<div className="page-content">

				<div className="o-grid-4 export-compta-container">

					<div className="o-grid__item">
						<DatePicker name="start" label="Début"
							onChange={ handleChange }
							value={ state.start }
						/>
					</div>

					<div className="o-grid__item">
						<DatePicker name="end" label="Fin"
							onChange={ handleChange }
							value={ state.end }
						/>
					</div>

					<div className="o-grid__item" />
					<div className="o-grid__item" />

				</div>

				<div className="o-content u-margin-top-20 u-flex u-gap-25
					u-items-center">

					<a className="c-btn c-btn--extra"
						href={ '/export/export-facturation?debut=' + start
						+ '&fin=' + end } target="_blank"
						rel="noreferrer">
						Ancien export facturation
					</a>

				</div>

				<div className="o-content u-margin-top-20 u-flex u-gap-25
					u-items-center">

					<CheckboxEl checked={ isTrue(includes_exported) }
						onChange={ toggleExported }
						label="Exporter les déjà exportés"
						bemit={ ['white'] }
					/>

					<a className="c-btn c-btn--extra"
						href={ '/export/export-factures-et-avoirs?debut=' + start
						+ '&fin=' + end + inc_param } target="_blank"
						rel="noreferrer">
						Factures &amp; Avoirs
					</a>

					<a className="c-btn c-btn--extra"
						href={ '/export/export-virements?debut=' + start
						+ '&fin=' + end + inc_param } target="_blank"
						rel="noreferrer">
						Virements
					</a>

					<a className="c-btn c-btn--extra"
						href={ '/export/export-cheques?debut=' + start
						+ '&fin=' + end + inc_param } target="_blank"
						rel="noreferrer">
						Chèques
					</a>

					<a className="c-btn c-btn--extra"
						href={ '/export/export-abondement?debut=' + start
						+ '&fin=' + end + inc_param } target="_blank"
						rel="noreferrer">
						Abondement
					</a>

				</div>

				<div className="o-content">

					<div className="u-full-width u-margin-top-30">

						<a className="c-btn c-btn--extra c-btn--blue"
							href={ '/export/export-non-paye/?debut=' + start
							+ '&fin=' + end } target="_blank"
							rel="noreferrer">
							Export des commandes non réglées
						</a>

					</div>

				</div>

			</div>

		</Layout>
	);
});